var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('reflection-item',{attrs:{"reflection":_vm.reflection,"isEditable":true}})}
var staticRenderFns = []

export { render, staticRenderFns }